const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? "/naavik";
const mediaUrl = process.env.NEXT_PUBLIC_MEDIA_URL || "";
const imagePathPattern = /\.(png|jpe?g|webp|svg|gif|avif|ico|bmp)$/i;

function looksLikeImagePath(path: string) {
  if (!path.startsWith("/")) {
    return false;
  }

  return imagePathPattern.test(path) || path.includes("/images/") || path.includes("/uploads/");
}

function createMediaProxyUrl(path: string) {
  // const normalizedPath = encodeURIComponent(path);
  const normalizedPath = path;
  return `https://naavik.ai/media${normalizedPath}`;
}

export function withBasePath(path: string) {
  if (!path.startsWith("/") || path.startsWith("//") || !basePath) {
    return path;
  }

  if (looksLikeImagePath(path)) {
    return createMediaProxyUrl(path);
  }

  return `${basePath.replace(/\/$/, "")}${path}`;
}

export function withMediaUrl(url?: string | null) {
  if (!url) {
    return "";
  }

  const trimmedUrl = url.trim();

  if (!trimmedUrl) {
    return "";
  }

  if (trimmedUrl.startsWith("http://") || trimmedUrl.startsWith("https://") || trimmedUrl.startsWith("//")) {
    return createMediaProxyUrl(trimmedUrl);
  }

  if (trimmedUrl.startsWith("/")) {
    return createMediaProxyUrl(trimmedUrl);
  }

  return trimmedUrl;
}
